import React from 'react';
import Section from './Section';

function HonorsAndAwards() {
  return (
    <Section title="Honors and Awards">
      <dl>
        <dt>Zell Miller Scholarship Recipient</dt>
        <dd>University of Georgia, 2022 – Present</dd>
        <dt>Star Sailor Award</dt>
        <dd>University of Georgia Sailing Club, 2023</dd>
      </dl>
    </Section>
  );
}

export default HonorsAndAwards;